/* index.js */

"use strict";
module.exports = require("./GroupingComponent");
